import React, {useMemo} from "react";
import Form from "../../base/form";
import {Col, Row} from "reactstrap";
import {InputForm} from "../../base/input/input";
import {DatePickerForm} from "../../base/date-picker";
import Button from "../../base/button/button";
import {DropdownForm} from "../../base/dropdown/dropdown";
import {MuiRFF, Yup} from '../../form'
import DateUtils from "../../../../core/services/date-utils";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";


const types = [
    {id: 0, title: 'All'},
    {id: 1, title: 'Add'},
    {id: 2, title: 'Remove'},
]

const formValues = {
    keyword: 'keyword',
    type: 'type',
    startDate: 'startDate',
    endDate: 'endDate',
}

const schema = Yup.object().shape({
    [formValues.keyword]: Yup.string().nullable(),
    [formValues.type]: Yup.object().nullable(),
    [formValues.startDate]: Yup.mixed()
        .validDate(ValidateMessages.incorrect)
        .maxDate(Yup.ref(formValues.endDate), ValidateMessages.lessThan('End Date'))
        .disableFutureDate(ValidateMessages.maxDate("today"), 'day')
        .nullable(),
    [formValues.endDate]: Yup.mixed()
        .validDate(ValidateMessages.incorrect)
        .minDate(Yup.ref(formValues.startDate), ValidateMessages.greaterThan('Start Date'))
        .disableFutureDate(ValidateMessages.maxDate("today"), 'day')
        .nullable(),
});

const validate = MuiRFF.makeValidate(schema);
const required = MuiRFF.makeRequired(schema);

const InventoryAdjustmentListSearchSection = ({searchData}) => {

    /**
     * Memo version of the initial values in the form
     */
    const initialValues = useMemo(() => ({
        [formValues.keyword]: searchData.filters?.keyword,
        [formValues.startDate]: searchData.filters?.startDate ? DateUtils.serverToUTC(searchData.filters?.startDate) : undefined,
        [formValues.endDate]: searchData.filters?.endDate ? DateUtils.serverToUTC(searchData.filters?.endDate) : undefined,
        [formValues.type]: types.find(e => e.id === searchData.filters?.type),
    }), [searchData.filters]);


    /**
     * Submits the changes in the search section by changing the query parameters in the url
     * @param values
     */
    const onSubmit = async (values) => {
        searchData.setFilters?.((prevState) => ({
            ...prevState,
            keyword: !!values[formValues.keyword] ? values[formValues.keyword] : null,
            type: values?.[formValues.type]?.id ?? undefined,
            startDate: values[formValues.startDate] ? DateUtils.UTCToServer(values[formValues.startDate]).format(DateUtils.withoutOffsetFormat) : undefined,
            endDate: values[formValues.endDate] ? DateUtils.UTCToServer(values[formValues.endDate]).format(DateUtils.withoutOffsetFormat) : undefined,
        }))
    }

    return (
        <Form
            onSubmit={onSubmit}
            validate={validate}
            initialValues={initialValues}
            className={'d-flex w-100 align-items-center justify-content-center'}
            render={({values, form}) => {
                return (
                    <Row className='d-flex w-100 align-items-center justify-content-center'>
                        <Col xs={12} className={'mb-3'}>
                            <InputForm
                                onChange={(val) => form.change(formValues.keyword, val)}
                                value={values[formValues.keyword] ?? ''}
                                label={'Keyword'}
                                name={formValues.keyword}
                                type={'text'}
                                required={required[formValues.keyword]}
                            />
                        </Col>
                        <Col xs={12} className={'mb-3'}>
                            <DropdownForm
                                padding={'3px 15px'}
                                label={'Type'}
                                className={'py-0'}
                                name={formValues.type}
                                required={false}
                                data={types.map(e => ({
                                    value: e,
                                    label: e.title,
                                    id: e.id,
                                })) ?? []}
                            />
                        </Col>
                        <Col xs={12} md={6} className={'mb-3'}>
                            <DatePickerForm
                                name={formValues.startDate}
                                label={'Start Date'}
                                required={required[formValues.startDate]}
                                maxDate={values[formValues.endDate]}
                                disableFuture
                            />
                        </Col>
                        <Col xs={12} md={6} className={'mb-3'}>
                            <DatePickerForm
                                name={formValues.endDate}
                                label={'End Date'}
                                required={required[formValues.endDate]}
                                minDate={values[formValues.startDate]}
                                disableFuture
                            />
                        </Col>
                        <Col xs={12}
                             className='px-3 mt-2 align-items-center row no-gutters justify-content-center align-items-center'>
                            <Button
                                disabled={searchData.loading}
                                type={'submit'}
                                variant={'contained'}
                                color={'primary'}
                                className='py-3 px-8'
                            >
                                {
                                    searchData.loading
                                        ? "Searching..."
                                        : "Search"
                                }
                            </Button>
                        </Col>
                    </Row>
                );
            }}
        />
    );
}

export default InventoryAdjustmentListSearchSection;
